import { render } from "./aiBrandList.vue?vue&type=template&id=0cc513c4&scoped=true"
import script from "./aiBrandList.vue?vue&type=script&lang=js"
export * from "./aiBrandList.vue?vue&type=script&lang=js"

import "./aiBrandList.vue?vue&type=style&index=0&id=0cc513c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc513c4"]])

export default __exports__